export default {
  blue: '#0066CC',
  blueLight: '#00A6ED',
  blueDark: '#0D2C54',
  red: '#E40046',
  // redLight: "#FCE7EE",
  redLight: '#FAD0DD',
  violet: '#A05EB5',
  green: '#00965E',
  greenLight: '#7FB800',
  yellow: '#FFB400',
  orange: '#F6511D',
  orangeLight: '#FBE9D0',
  white: '#FFFFFF',
  black: '#000000',
  gray: '#5C6975',
  grayLight: '#717171',
  grayDark: '#2A2A2A',
  bgWhite:'#F8F8F8',
  dabblelabOrage: '#F65437',
};
